/** @module ProductSpec/ReviewPropertiesNodeNameRenderer */
define([
       "dojo/_base/declare",
       "csi/heading/String"
], function(declare,StringRen) {

	return declare(StringRen, {
		/*
		*@override
		*/
		canLink: function() {
			return false;
		}
	});
});